export default __webpack_public_path__ + "static/media/low_light_pink.1686ea9c.png";